<h1 mat-dialog-title class="text-center mb-0 fw-bold">Add Telegram Bot</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
    <div class="container">
        <div class="row" [formGroup]="telegramForm">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Enter Bot Token</mat-label>
                <mat-error *ngIf="telegramForm.controls['botKey'].hasError('required')">You need to enter your Bot Token</mat-error>
                <input matInput placeholder="Token" formControlName="botKey">
            </mat-form-field>
        </div>
    </div>

</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading">Close</button>
    <button (click)="onSubmit()" mat-raised-button class="w-25" color="primary" [disabled]="!telegramForm.valid || isLoading">
        <span *ngIf="!isLoading">
            {{isEditing ? 'Save' : 'Add'}}
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
        </button>
</mat-dialog-actions>